import { createGlobalStyle } from 'theme';

export const Anchor = createGlobalStyle`
  a {
    text-decoration: none;
    transition: color 300ms ease-out;
  }
`;
